import { Fragment, useEffect, useState } from "react"
import { Link, useSearchParams } from "react-router-dom";
import config from "../config";
import { DocumentThumbnailLink, DocumentListItem, DocumentThumbnailList, LoadingBar, Container } from "./Elements";
import DocumentListFilterWrapper from "./DocumentListFilterWrapper";
import PaginationButtons from "./PaginationButtons";
import helpers from "../helpers";
import MapView from "./MapView";

export default function DocumentList(props) {
	const [searchParams, setSearchParams] = useSearchParams();
	const [loading, setLoading] = useState(true);

	const [data, setData] = useState([]);
	const [nextUrl, setNextUrl] = useState(null);
	const [previousUrl, setPreviousUrl] = useState(null);
	const [resultCount, setResultCount] = useState(0);
	const [notFound, setNotFound] = useState(false);
	const [listMode, setListMode] = useState('list');
	const [listOrder, setListOrder] = useState('shelfmark');
	const [showMap, setShowMap] = useState(false);
	const [mapData, setMapData] = useState([]);
	
	const l = window.l;

	const pageSize = 100;

	useEffect(() => {
		console.log('searchParams:')
		console.log(searchParams)

		setLoading(true);
		setNotFound(false);

		let params = helpers.getApiParams(searchParams);
		console.log('params í byrjun')
		console.log(params)
		
		let mapParams = params.slice();
		//mapParams.push('origin=true');
		mapParams.push('has_latlng=true');
		mapParams.push('limit=2000');

		fetch(config.apiRoot+'farms?'+mapParams.join('&'))
		.then(res => res.json())
		.then(json => {
			setMapData(json.results);
		});
		
		params.push('order='+listOrder);

		console.log('sæki dót')
		console.log(params)

		fetch(config.apiRoot+'search?'+params.join('&'))
			.then(res => res.json())
			.then(json => {
				setData(json.results);
				setNextUrl(json.next);
				setPreviousUrl(json.previous);
				setResultCount(json.count);
				setNotFound(json.count == 0);
				setLoading(false);
			});
		
			if (searchParams.has('sida')) {
				//window.scrollTo(0, 0);
			}
	}, [searchParams, listOrder]);

	return <Container className={'relative mt-10 '+(props.className)}>

		<DocumentListFilterWrapper currentLang={props.currentLang} 
			mapData={mapData}
			showMap={showMap}
			filterRowContent={
				data.length > 0 && <div className="flex justify-end items-center mb-5">				
					<div className="mr-5 text-sm text-right">{resultCount} {l('documents found')}</div>

					<button className={'inline-block p-2 rounded-l text-sm'+(listMode == 'list' ? ' text-white bg-sam_green' : ' bg-gray-200')} onClick={() => setListMode('list')}>{l('List')}</button>
					<button className={'inline-block p-2 rounded-r mr-2 text-sm'+(listMode == 'grid' ? ' text-white bg-sam_green' : ' bg-gray-200')} onClick={() => setListMode('grid')}>{l('Grid')}</button>

					<div className="ml-3 h-full text-sm border-l border-gray-300 pl-3"></div>
					<div className="mr-2 text-sm text-gray-800">{l('Order')}</div>
					<button className={'inline-block p-2 rounded-l text-sm'+(listOrder == 'shelfmark' ? ' text-white bg-sam_green' : ' bg-gray-200')} onClick={() => setListOrder('shelfmark')}>{l('Shelfmark')}</button>
					<button className={'inline-block p-2 rounded-r mr-2 text-sm'+(listOrder == 'date_written' ? ' text-white bg-sam_green' : ' bg-gray-200')} onClick={() => setListOrder('date_written')}>{l('Year written')}</button>

					{
						mapData.length > 0 && <Fragment>
							<div className="ml-3 h-full text-sm border-l border-gray-300 pl-3"></div>
							<button className={'inline-block p-2 rounded-l text-sm'+(showMap ? ' text-white bg-sam_green' : ' bg-gray-200')} onClick={() => setShowMap(!showMap)}><span className={'mr-2 text-xl leading-none '+(showMap ? ' text-white' : ' text-gray-300')} >&#10004;</span>{l('Show map')}</button>
						</Fragment>
					}
				</div>
			}
		>
			<LoadingBar loading={loading} />

			{
				notFound && <div className="font-lido text-center py-10">
					<div className="text-2xl">{l('No documents were found under these search conditions')}</div>
					<Link className="block text-xl text-sam_theme mt-5" to={'/bref/'}>{l('Show all documents')}</Link>
				</div>
			}

			{
				data.length > 0 && <DocumentThumbnailList className={'mb-36 transition-all'+(loading ? ' opacity-50 pointer-events-none' : '')} listMode={listMode}>
					{
						data.map((item, index) => listMode && listMode == 'list' ? <DocumentListItem key={index} 
						data={item} searchString={searchParams.get('leit')}
					/> : <DocumentThumbnailLink key={index} 
						data={item} 
					/>)
					}
				</DocumentThumbnailList>
			}

		{
			resultCount > pageSize && <div className="fixed bottom-0 left-0 right-0 bg-white shadow-xl border-t border-gray-300 z-[500]">
				<PaginationButtons resultCount={resultCount}
					previousUrl={previousUrl}
					nextUrl={nextUrl} />
			</div>
		}

		</DocumentListFilterWrapper>

	</Container>
}